"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.ConfiguratorModelSelector = void 0;
var _configuratorModelSelector = _interopRequireDefault(require("./components/configurator-model-selector"));
exports.ConfiguratorModelSelector = _configuratorModelSelector["default"];